import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import CreateRateForm from "@/components/app/CreateRateForm";
import ListRateTable from "@/components/app/ListRateTable";


export default /*#__PURE__*/_defineComponent({
  __name: 'RateView',
  setup(__props) {


// Define component properties
const rateTable = ref()
// Define methods
function itemCreatedHandler(data:any) {
  rateTable.value.reload()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(CreateRateForm), { onItemCreated: itemCreatedHandler }),
    _createVNode(_unref(ListRateTable), {
      ref_key: "rateTable",
      ref: rateTable
    }, null, 512)
  ], 64))
}
}

})